<li class=" stepper__step list-group-item p-0 border-0 "
  [ngClass]="{
    'stepper__step--approved': step.approved && step.date,
    'stepper__step--rejected': !step.approved && step.date,
    'hide-left-union' : first,
    'hide-right-union' : last
  }"
  (mouseenter)="onHover()"
  >
  <!-- (mouseleave)="onLeaving()" -->
  <div class="rounded-circle " [ngClass]="{
    'correct-icon-position-tiny-approved': (step.approved && step.date) && variant === 'tiny',
    'correct-icon-position-full-approved': (step.approved && step.date) && variant === 'full',
    'correct-icon-position-tiny-pending': !step.date && variant === 'tiny',
    'correct-icon-position-full-pending': !step.date && variant === 'full',
    'correct-icon-position-full-rejected': step.date && !step.approved && variant === 'full',
    'correct-icon-position-tiny-rejected': step.date && !step.approved && variant === 'tiny'
  }">
  </div>
  <p *ngIf="!withDate"> {{step.name}}</p>
  <p *ngIf="withDate">
    {{step.name}}<br>
    {{step.date | date: 'dd/MM/yyyy'}}
  </p>
</li>

